import { Link } from "react-router-dom";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import * as Constants from "../../constants/urls";

const ExcelIndex=()=>{
    return(
        <>
                                        {/* <Breadcrumb title={"ایجاد گزارش"} /> */}

        <div style={{display:"flex",alignItems:"center", background:"url('" + Constants.watermarkUrl + "')",backgroundRepeat:"no-repeat",minHeight:"90vh",backgroundPosition:"center",backgroundColor:"#fff"}}>
        <div className="container" >
          <Link to={"/admin/excel/sell-report"}>
          <div className={[' btn btn-block btn-info py-4 my-2 text-white border border-white'].join(' ')} style={{direction: 'rtl',opacity:"0.9"}}>
                 <strong className={['m-0 text-center', 'p-0'].join(' ')}>گزارش فروش محصولات</strong>
            </div>
            </Link>
            <Link to={"/admin/excel/sell-tax-report"}>
          <div className={[' btn btn-block btn-info py-4 my-2 text-white border border-white'].join(' ')} style={{direction: 'rtl',opacity:"0.9"}}>
                 <strong className={['m-0 text-center', 'p-0'].join(' ')}>گزارش فروش مالیاتی محصولات</strong>
            </div>
            </Link>
            <Link to={"/admin/excel/warehouse-receipt-report"}>
          <div className={[' btn btn-block btn-info py-4 my-2 text-white border border-white'].join(' ')} style={{direction: 'rtl',opacity:"0.9"}}>
                 <strong className={['m-0 text-center', 'p-0'].join(' ')}> گزارش رسید انبار </strong>
            </div>
            </Link>
            <Link to={"/admin/excel/warehouse-receipt-tax-report"}>
          <div className={[' btn btn-block btn-info py-4 my-2 text-white border border-white'].join(' ')} style={{direction: 'rtl',opacity:"0.9"}}>
                 <strong className={['m-0 text-center', 'p-0'].join(' ')}> گزارش رسید انبار مالیاتی</strong>
            </div>
            </Link>
            </div>
            </div>
         </>
    )
}
export default ExcelIndex;